
import { Link } from 'react-router-dom'
const Breadcrumb = ({ title, midBreadcrumb, mainBreadcrumb }) => {
    return (
        <>
            <div className="bread_img">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/abt-bg.jpg" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
                <div className="bread-content">
                    <h1>{title}</h1>
                    <ol className="breadcrumb">
                        <li className="active"><Link to="/">Home</Link></li>
                        <li>{midBreadcrumb}</li>
                        <li>{mainBreadcrumb}</li>
                    </ol>
                </div>
            </div>
        </>
    )
}
export default Breadcrumb